import { forwardRef } from "react";
import type { HTMLAttributes, Ref } from "react";
import { cn } from "../../../styles";

const outerStyles = [
  "[.fill>&]:grow [.fill>&]:relative [.fill>&]:h-full",
  "[.fill>.portal>&]:grow [.fill>.portal>&]:relative [.fill>.portal>&]:h-full",
].join(" ");

const innerFillStyles = [
  "[.fill>*>&]:absolute [.fill>*>&]:h-full [.fill>*>&]:overflow-auto",
  "[.fill>.portal>*>&]:absolute [.fill>.portal>*>&]:h-full [.fill>.portal>*>&]:overflow-auto",
].join(" ");

const innerFullHeightStyles = [
  "[.full-height>*>&]:static [.full-height>*>&]:overflow-visible",
  "[.full-height>.portal>*>&]:static [.full-height>.portal>*>&]:overflow-visible",
].join(" ");

const innerContentWidthStyles = [
  "[.content-width>*>&]:w-auto",
  "[.content-width>.portal>*>&]:w-auto",
].join(" ");

interface LayoutItemProps extends HTMLAttributes<HTMLDivElement> {
  gutters?: boolean;
  gutterTop?: boolean;
  gutterRight?: boolean;
  gutterLeft?: boolean;
  gutterBottom?: boolean;
  guttersVertical?: boolean;
  guttersHorizontal?: boolean;
}

function LayoutItemInner(
  {
    children,
    className,
    gutters,
    gutterTop,
    gutterRight,
    gutterLeft,
    gutterBottom,
    guttersVertical,
    guttersHorizontal,
    ...props
  }: LayoutItemProps,
  ref: Ref<HTMLDivElement>,
) {
  return (
    <div className={outerStyles}>
      <div
        {...props}
        ref={ref}
        className={cn(
          "w-full",
          innerFillStyles,
          innerFullHeightStyles,
          innerContentWidthStyles,
          gutters && "px-4 py-3",
          gutterTop && "pt-3",
          gutterRight && "pr-4",
          gutterLeft && "pl-4",
          gutterBottom && "pb-3",
          guttersVertical && "py-3",
          guttersHorizontal && "px-4",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
}

export const LayoutItem = forwardRef(LayoutItemInner);
